import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './mobile/mobile.css';
import App from './App';
import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
try { document.documentElement.dataset.theme = localStorage.getItem('what-mobile:theme') === 'dark' ? 'dark' : 'light'; } catch (_) {}
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}));
}
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
